import { render, staticRenderFns } from "./create-problem-report-modal.vue?vue&type=template&id=308c3d80"
import script from "./create-problem-report-modal.vue?vue&type=script&lang=js"
export * from "./create-problem-report-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports